import React from "react";

import OverflowTooltip from "components/overflowTooltip";
import { getDuration, getFormattedDate } from "helpers";

import styles from "../historyTable.module.scss";

const dateTimeColumn = () => ({
	Header: "Date & Time",
	accessor: "created_at",
	disableSortBy: true,
	classNameHeader: styles.dateHeaderCol,
	classNameCell: styles.dateCol,
	Cell: ({ cell }) => {
		const duration = getDuration({ start: cell?.value });
		return (
			<OverflowTooltip onlyOnLaptop title={duration}>
				{getFormattedDate({ date: cell?.value })}
			</OverflowTooltip>
		);
	},
});

export default dateTimeColumn;
